import * as React from "react"
import Image from "gatsby-image"

// Styles
import "./_fullscreen-image.scss"

// Components
import { Section } from "../StyledComponents/layoutComponentStyles"

interface FullscreenImageProps {
  module: any
}

/*









*/

const FullscreenImage: React.FunctionComponent<FullscreenImageProps> = ({ module }) => {
  return (
    <Section>
      <div className={module.modifiers ? `project-img__full ${module.modifiers}` : "project-img__full"}>
        <Image fluid={module.image.image.asset.fluid} alt={module.image.altText} className='project-img-full__asset' />
      </div>
    </Section>
  )
}

export default FullscreenImage
